import request from "../../utils/request";

export function getAllUsers(params) {
  return request("/users", {
    method: "GET",
    params,
  });
}

export function doCreateUser(params) {
  return request("/users", {
    method: "POST",
    data: params,
  });
}

export function doUpdateUser(params) {
  return request(`/users/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doDeleteUser(id) {
  return request(`/users/${id}`, {
    method: "DELETE",
  });
}

export function doFindEmails(params) {
  return request("/users/find-emails", {
    method: "GET",
    params,
  });
}
